import { example } from "@/api/dataList";
export async function ceshi({ json }) {
    const a = await new Promise((resolve, reject) => {
        var data1 = {
            search: JSON.stringify(json)
        }
        example(data1).then((res) => {
            if (res.code == 1) {
                var example = [];
                var value = [];
                example = res.data[0].content
                // for (var key in res.data.data[0].content) {
                //     example.push(res.data.data[0].content[key].label);
                //     value.push(res.data.data[0].content[key].value
                //     );
                //     /* value.push({
                //         [valueKey]: res.data.data[0].content[key].value,
                //     }); */
                // }
                return resolve({
                    example,
                    value
                });
            }
        });

    });
    return a
} 